import axios from 'axios';

export const getSheetData = async (accessToken, sheetId) => {
  try {
    const response = await axios.get(
      `https://sheets.googleapis.com/v4/spreadsheets/${sheetId}/values/A1:Z1000`,
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );

    // Process the response data
    const rows = response.data.values || [];
    if (rows.length === 0) {
      return [];
    }

    // Assuming first row contains headers
    const headers = rows[0];
    
    // Convert the data to our required format
    return rows.slice(1).map((row, index) => {
      const cells = {};
      headers.forEach((header, i) => {
        cells[header] = row[i] || '';
      });
      
      return {
        rowId: String(index + 1),
        language: cells.language || 'Unknown',
        cells
      };
    });
  } catch (error) {
    console.error('Error fetching sheet data:', error);
    throw error;
  }
}; 